import InputFile from './input-file.element.js';

export default InputFile;

InputFile.define('wje-input-file', InputFile);
